import React, { useContext, useEffect, useState } from "react";
import "./Finance.scss";
import { Pie } from "react-chartjs-2";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import Loading from "../../components/Loading/Loading";
import Header from "../../components/Header.jsx";
import { MdOutlineCreditCard } from "react-icons/md";
import { GiReceiveMoney } from "react-icons/gi";
import { FaWallet } from "react-icons/fa";
import { useAuth } from "../../context/Auth.js";
import { toast } from "react-toastify";

ChartJS.register(ArcElement, Tooltip, Legend);

const Finance = () => {
  const {requestWithAuth} = useAuth()
  const [overviewData, setOverviewData] = useState({});
  const [dataFetched, setDataFetched] = useState(false);
  const [pieChartData, setPieChartData] = useState([]);
  const [recentIncomes, setRecentIncomes] = useState([])

  const options = {
    responsive: true,
    maintainAspectRatio: false, 
    cutout: "70%", 
    plugins: {
      legend: {
        display: false, 
      },
      tooltip: {
        enabled: true, 
      },
    },
    
  };

  // GET OVERVIEW DATA
  const getFinancialOverview = async () => {
    try {
      const responseData = await requestWithAuth(`/finance/overview/`, 'GET',{
        "Content-Type":"application/json"
      });
     


      setPieChartData({
        labels: ["Income", "Expense"],
        datasets: [
          {
            label: "Total",
            data: [responseData.total_income, responseData.total_expenses],
            backgroundColor: ["#599BF2", "#9747FF"],
          },
        ],
      });

     

      setOverviewData(responseData);
      setRecentIncomes(responseData.recent_incomes)
      setDataFetched(true);
    } catch (error) {
      toast.error("Failed to get Financial Data");
    }
  };



  useEffect(() => {
    getFinancialOverview();
  }, []);

  if (!dataFetched) {
    return <Loading />;
  }
  return (
    <div>

      <Header title="CHURCH FINANCES" />

      <div className="grid grid-cols-3 gap-10">
        <div className="shadow-md rounded p-5 border border-gray-200">
          <div className="flex items-center gap-2">
            <div className="h-12 w-12 rounded-full bg-purple-600 flex items-center justify-center text-white">
              <MdOutlineCreditCard className="text-2xl" />
            </div>
            <div className="flex flex-col">
              <h5 className="text-sm font-semibold text-gray-500">
                Total Balance
              </h5>
              <h2 className="text-3xl font-[500]">GHS {overviewData?.net_income}</h2>
            </div>
          </div>
        </div>

        <div className="shadow-md rounded p-5 border border-gray-200">
          <div className="flex items-center gap-2">
            <div className="h-12 w-12 rounded-full bg-orange-600 flex items-center justify-center text-white">
              <FaWallet className="text-2xl" />
            </div>
            <div className="flex flex-col">
              <h5 className="text-sm font-semibold text-gray-500">
                Total Income
              </h5>
              <h2 className="text-3xl font-[500]">GHS {overviewData?.total_income}</h2>
            </div>
          </div>
        </div>

        <div className="shadow-md rounded p-5 border border-gray-200">
          <div className="flex items-center gap-2">
            <div className="h-12 w-12 rounded-full bg-red-600 flex items-center justify-center text-white">
              <GiReceiveMoney className="text-xl" />
            </div>
            <div className="flex flex-col">
              <h5 className="text-sm font-semibold text-gray-500">
                Total Expense
              </h5>
              <h2 className="text-3xl font-[500]">GHS {overviewData?.total_expenses}</h2>
            </div>
          </div>
        </div>
      </div>

      <div className="grid grid-cols-2 mt-6 gap-10">
        <div className="shadow-md border border-gray-200 rounded p-5">
          <div className="flex justify-between items-center">
            <h2 className="font-[500] text-lg">Recent Income</h2>
            
          </div>
          <div className="py-8">
            {
              recentIncomes?.map((income, index)=>(
                <div key={index} className="flex items-center justify-between mb-2 border-b border-gray-200 pb-2">
                  <div>
                    <p className="text-lg font-[500]">{income.income_type?.name}</p>
                    <p className="text-sm text-gray-600">{income.date_received}</p>
                  </div>
                  <div className="p-2 bg-green-100 text-green-500 font-semibold text-sm rounded-lg">
                    GHS{income.amount_received}
                  </div>
                </div>
              ))
            }
          </div>
        </div>
        <div className="shadow-md border border-gray-200 rounded p-5">
          <div className="flex justify-between items-center">
            <h2 className="font-[500] text-lg">Financial Overview</h2>
            
          </div>
          <div className="py-8 flex items-center justify-center" >
            <div className="">
              <div style={{width:"300px", height:"300px", margin:"auto"}}>
                <Pie data={pieChartData} options={options} />
              </div>
              <div className="flex items-center gap-7 mt-4">
               
                <div className="flex items-center gap-1">
                  <div className="w-2 h-2 bg-purple-600 rounded-full"></div>
                  <p>Total Income</p>
                </div>
                <div className="flex items-center gap-1">
                  <div className="w-2 h-2 bg-blue-400 rounded-full"></div>
                  <p>Total Expense</p>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>

      
    </div>
  );
};

export default Finance;
